export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-lg mx-auto">
            有任何建议、反馈或合作意向？欢迎通过以下方式与我们取得联系
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
            <div className="p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer group">
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="ri-mail-line text-primary-600 group-hover:text-background-50 text-xl transition-colors duration-300"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 font-heading mb-1">意见反馈</h3>
              <p className="text-xs text-foreground-500">feedback@58cinema.com</p>
            </div>

            <div className="p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer group">
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3 group-hover:bg-accent-500 transition-colors duration-300">
                <i className="ri-service-line text-accent-600 group-hover:text-background-50 text-xl transition-colors duration-300"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 font-heading mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">biz@58cinema.com</p>
            </div>

            <div className="p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer group">
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="ri-chat-smile-2-line text-primary-600 group-hover:text-background-50 text-xl transition-colors duration-300"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 font-heading mb-1">剧集投稿</h3>
              <p className="text-xs text-foreground-500">submit@58cinema.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}